var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serviceIncomeCell"},[_c('div',[_c('div',[_vm._v("团长服务费率："+_vm._s(_vm.row.income_commission_rate)+"%")]),_c('div',[_vm._v("预估收入：￥"+_vm._s(_vm.row.income_estimated_commission))]),_c('div',[_vm._v("实际收入：￥"+_vm._s(_vm.row.income_real_commission))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }